import { Controller } from "@hotwired/stimulus"
import {
  Chart,
  RadarController,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip
} from "chart.js"

Chart.register(RadarController, RadialLinearScale, PointElement, LineElement, Filler, Tooltip)

export default class extends Controller {
  static targets = ["canvas"]
  static values = {
    labels: Array,      // ["Frappe", "Volée", "Lob", "Service", "Déplacement", "Tactique"]
    current: Array,     // [3.2, null, 4.1, 2.8, 3.5, null]
    previous: Array,    // [2.8, null, 3.5, 2.2, 3.0, null]
    maxScore: { type: Number, default: 5 },
    mini: { type: Boolean, default: false }
  }

  connect() {
    this.renderChart()
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  }

  renderChart() {
    const datasets = []

    // Current dataset (blue filled)
    datasets.push({
      label: "Niveau actuel",
      data: this.currentValue.map(v => v ?? 0),
      backgroundColor: "rgba(59, 130, 246, 0.2)",
      borderColor: "rgba(59, 130, 246, 1)",
      borderWidth: 2,
      pointBackgroundColor: "rgba(59, 130, 246, 1)",
      pointRadius: this.miniValue ? 2 : 4
    })

    // Previous dataset (gray dashed) if provided
    if (this.hasPreviousValue && this.previousValue.some(v => v !== null)) {
      datasets.push({
        label: "Niveau précédent",
        data: this.previousValue.map(v => v ?? 0),
        backgroundColor: "rgba(148, 163, 184, 0.1)",
        borderColor: "rgba(148, 163, 184, 0.5)",
        borderWidth: 1,
        borderDash: [5, 5],
        pointRadius: this.miniValue ? 1 : 2
      })
    }

    this.chart = new Chart(this.canvasTarget, {
      type: "radar",
      data: {
        labels: this.labelsValue,
        datasets
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        scales: {
          r: {
            min: 0,
            max: this.maxScoreValue,
            ticks: {
              stepSize: 1,
              display: !this.miniValue
            },
            pointLabels: {
              font: { size: this.miniValue ? 8 : 12 },
              display: !this.miniValue
            },
            grid: {
              color: "rgba(148, 163, 184, 0.3)"
            }
          }
        },
        plugins: {
          tooltip: {
            enabled: !this.miniValue,
            callbacks: {
              label: (ctx) => `${ctx.dataset.label}: ${ctx.raw}/5`
            }
          },
          legend: {
            display: !this.miniValue,
            position: "bottom",
            labels: {
              font: { size: 11 },
              usePointStyle: true,
              pointStyle: "circle"
            }
          }
        }
      }
    })
  }
}
